
class PublicService {
    fetchEventById(id) {
        return fetch(`${process.env.PREACT_APP_PUBLIC_URL}/events/${id}`);
    }

    fetchCustomer(shopifyCustomerId, shopifyCustomerEmail) {
        return fetch(`${process.env.PREACT_APP_PUBLIC_URL}/customer/${shopifyCustomerId}/${shopifyCustomerEmail}`)
    }

    fetchMembershipProducts() {
        return fetch(`${process.env.PREACT_APP_PUBLIC_URL}/membership-products`)
    }

    fetchSchoolsByQuery(query) {
        return fetch(`${process.env.PREACT_APP_PUBLIC_URL}/schools?search=${query}`);
    }

    fetchAdditionalFeatures(optionId) {
        return fetch(`${process.env.PREACT_APP_PUBLIC_URL}/event-period-options/${optionId}/features`)
    }
}

export default new PublicService;
